import i18n from '@/i18n';
import { getCurrentCountry } from '@/utils/domain';
import { shouldHideSender } from '@/utils/hideSender';
import { ENV } from '.';

const { t } = i18n;

const currentCountry = getCurrentCountry();

function getPhoneNumberList(country) {
  switch (country) {
    case 'th':
      return ['66123434543', '6634345544'];
    case 'br':
      return ['55123434543', '5534345544'];
    default:
      return ['66123434543', '6634345544']; // default case
  }
}

const internalServerError = {
  500: {
    type: 'object',
    description: t('api_page.internal_server_error'),
    properties: {
      code: {
        type: 'string',
      },
      data: {
        type: 'object',
        schema: {
          request_id: 'string',
        },
      },
    },
  },
};

/* eslint-disable max-len */
export const ApiDocs = {
  // senders: [
  //   {
  //     name: 'Sender List',
  //     description: '',
  //     endpoint: `${ENV.OPEN_API_BASE_URL}/v1/sms/senders`,
  //     method: 'GET',
  //     headers: [
  //       {
  //         atribute: 'Authorization',
  //         required: true,
  //         description: 'When making requests to our API, include your API Key in the Authorization header using the <code>Bearer</code> authentication type. For example: <code>Authorization: Bearer {api_key}</code>.'
  //       },
  //     ],
  //     parameters: [],
  //     responses: {
  //       ...internalServerError,
  //       200: {
  //         type: 'object',
  //         properties: {
  //           code: {
  //             type: 'number',
  //           },
  //           data: {
  //             type: 'array of objects',
  //             schema: {
  //               id: 'string',
  //               sender_name: 'string'
  //             }
  //           }
  //         }
  //       },
  //     },
  //   },
  // ],
  smsMKT: [
    {
      name: t('api_page.documents.sms_mkt.send_sms_marketing'),
      description: '',
      endpoint: `${ENV.OPEN_API_BASE_URL}/v1/sms/marketing`,
      method: 'POST',
      headers: [
        {
          atribute: 'Authorization',
          required: true,
          description: t('api_page.documents.sms_mkt.authorization.desc'),
        },
      ],
      parameters: [
        {
          atribute: 'reference_id',
          required: true,
          type: 'string',
          description: t('api_page.documents.sms_mkt.reference_id.desc'),
        },
        ...(shouldHideSender(currentCountry)
          ? []
          : [
              {
                atribute: 'sender_id',
                required: true,
                type: 'string',
                description: t('api_page.documents.sms_mkt.sender_id.desc'),
              },
            ]),
        {
          atribute: 'phone_number_list',
          required: true,
          type: 'string[]',
          description: t('api_page.documents.sms_mkt.phone_number_list.desc', {
            phone_number: getPhoneNumberList(currentCountry).join(', '),
          }),
        },
        {
          atribute: 'content',
          required: true,
          type: 'string',
          description: t('api_page.documents.sms_mkt.content'),
        },
      ],
      responses: {
        ...internalServerError,
        200: {
          type: 'object',
          properties: {
            code: {
              type: 'string',
            },
            data: {
              type: 'object',
              schema: {
                reference_id: 'string',
                // conditionally remove the sender_id depending on the current br
                ...(!shouldHideSender(currentCountry) && {
                  sender_id: 'string',
                }),
                phone_number_list: 'array',
                content: 'string',
              },
            },
          },
        },
      },
    },
    // {
    //   name: 'Detail',
    //   description: '',
    //   endpoint: `${ENV.OPEN_API_BASE_URL}/v1/sms/marketing/<str:reference_id>`,
    //   method: 'GET',
    //   headers: [
    //     {
    //       atribute: 'Authorization',
    //       required: true,
    //       description: 'When making requests to our API, include your API Key in the Authorization header using the <code>Bearer</code> authentication type. For example: <code>Authorization: Bearer {api_key}</code>.'
    //     },
    //   ],
    //   parameters: [],
    //   responses: {
    //     ...internalServerError,
    //     200: {
    //       type: 'object',
    //       properties: {
    //         code: {
    //           type: 'number',
    //         },
    //         data: {
    //           type: 'array of object',
    //           schema: {
    //             phone_number_list: 'array',
    //             content: 'string',
    //             status: 'string'
    //           }
    //         }
    //       }
    //     },
    //   },
    // },
  ],
  smsOTP: [
    {
      name: t('api_page.documents.sms_otp.send_otp'),
      description: '',
      endpoint: `${ENV.OPEN_API_BASE_URL}/v1/sms/otp`,
      method: 'POST',
      headers: [
        {
          atribute: 'Authorization',
          required: true,
          description: t('api_page.documents.sms_otp.authorization.desc'),
        },
      ],
      parameters: [
        {
          atribute: 'reference_id',
          required: true,
          type: 'string',
          description: t('api_page.documents.sms_otp.reference_id.desc'),
        },
        ...(shouldHideSender(currentCountry)
          ? []
          : [
              {
                atribute: 'sender_id',
                required: true,
                type: 'bigint',
                description: t('api_page.documents.sms_otp.sender_id.desc'),
              },
            ]),
        {
          atribute: 'phone_number',
          required: true,
          type: 'string',
          description: t('api_page.documents.sms_otp.phone_number.desc', {
            phone_number: getPhoneNumberList(currentCountry).splice(0, 1),
          }),
        },
        {
          atribute: 'content',
          required: true,
          type: 'string',
          description: t('api_page.documents.sms_otp.content'),
        },
      ],
      responses: {
        ...internalServerError,
        200: {
          type: 'object',
          properties: {
            code: {
              type: 'string',
            },
            data: {
              type: 'object',
              schema: {
                reference_id: 'string',
                // conditionally remove the sender_id depending on the current br
                ...(!shouldHideSender(currentCountry) && {
                  sender_id: 'string',
                }),
                phone_number: 'string',
                content: 'string',
              },
            },
          },
        },
      },
    },
    // {
    //   name: 'OTP Detail',
    //   description: '',
    //   endpoint: `${ENV.OPEN_API_BASE_URL}/v1/sms/otp/<str:reference_id>`,
    //   method: 'GET',
    //   headers: [
    //     {
    //       atribute: 'Authorization',
    //       required: true,
    //       description: 'When making requests to our API, include your API Key in the Authorization header using the <code>Bearer</code> authentication type. For example: <code>Authorization: Bearer {api_key}</code>.'
    //     },
    //   ],
    //   parameters: [],
    //   responses: {
    //     ...internalServerError,
    //     200: {
    //       type: 'object',
    //       properties: {
    //         code: {
    //           type: 'number',
    //         },
    //         data: {
    //           type: 'array of object',
    //           schema: {
    //             phone_number: 'string',
    //             content: 'string',
    //             status: 'string'
    //           }
    //         }
    //       }
    //     },
    //   },
    // },
  ],
};
